import getTrigger from './get-trigger';

const NETWORKS = {
	facebook( url ) {
		const params = new URLSearchParams( { u: url } );
		return 'https://facebook.com/sharer/sharer.php?' + params.toString();
	},
	linkedin( url ) {
		const params = new URLSearchParams( { mini: true, url } );
		return 'https://www.linkedin.com/shareArticle?' + params.toString();
	},
	twitter( url ) {
		const params = new URLSearchParams( { url } );
		return 'https://twitter.com/intent/tweet/?' + params.toString();
	},
};

export function share( network, url ) {
	const builder = NETWORKS[ network ];

	const width = 800;
	const height = 600;
	const top = ( window.innerHeight - 600 ) / 2;
	const left = ( window.innerWidth - 800 ) / 2;

	window.open( builder( url ), 'share', `popup=1,width=${ width },height=${ height },top=${ top },left=${ left }` );
}

export default function setupShareButtons() {
	document.addEventListener( 'click', function( e ) {
		const button = getTrigger( e.target, '[data-share]' );
		if ( button ) {
			e.preventDefault();
			const network = button.dataset.share;
			const url = button.dataset.url || button.href || window.location.href;

			if ( e.pointerType === 'mouse' || ! navigator.share ) {
				share( network, url );
			} else {
				navigator.share( {
					title: document.title,
					url,
				} ).catch( () => {
					share( network.url );
				} );
			}
		}
	} );
}
